import React from 'react';
import styled from "styled-components";
import PreEFormMappingHeader from '../../PreEFormFields/PreEFormMappingHeader';
import PreEFormMapping from "../../../PreEForm/PreEFormMapping";
import Form from "react-bootstrap/Form";
const CheckBoxContainer = styled.div`
    overflow-x: hidden;
    padding-left: 0px;
    border: 1px solid grey
`;

const IPSLocations = ({ preEForm, preEFormMappings, assets, onChangeAssetId, selectAllAssets,saveVisibleText }) =>
    <CheckBoxContainer>
        <PreEFormMappingHeader />
        {preEFormMappings && preEFormMappings.length > 0 && preEFormMappings.map(preEFormMapping =>
            <PreEFormMapping
                 key={preEFormMapping.ipsLocationId}
                 ipsLocationId={preEFormMapping.ipsLocationId}
                 onChangeAssetId={onChangeAssetId}
                 selectAllAssets={selectAllAssets}
                 preEFormMapping={preEFormMapping}
                 currentFormId = {preEForm?.id}
                 saveVisibleText={!saveVisibleText}
            />
        )}

    </CheckBoxContainer>;

export default IPSLocations;